import { Box, Skeleton, Stack } from '@mui/material';
import React from 'react';

interface TableSkeletonProps {
  columns: number;
  rows: number;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ columns, rows }) => {
  return (
    <Box
      key={19292}
      sx={{
        width: '100%',
        padding: '1em',
        backgroundColor: '#Fff',
        borderRadius: '10px',
        minWidth: '800px',
        overflowX: 'auto',
      }}
    >
      {[...Array(rows)].map((_, i) => (
        <Box key={`row-${i}`} display="flex" alignItems="center" paddingY={1}>
          <Stack>
            <Skeleton
              variant="circular"
              width={35}
              height={35}
              sx={{
                marginRight: 2,
              }}
              key={`skeleton-avatar-${i}`}
            />
          </Stack>

          <Skeleton
            variant="text"
            sx={{
              marginRight: 2,
              borderRadius: '10px',
              width: '40%',
              height: '52px',
            }}
            key={`skeleton-text-${i}-0`}
          />

          {[...Array(columns - 1)].map((_, j) => (
            <Skeleton
              key={`skeleton-text-${i}-${j + 1}`} // Chave única para cada coluna
              variant="text"
              width="25%"
              height={"52px"}
              sx={{ marginRight: 2, borderRadius: '10px' }}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default TableSkeleton;